import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Router } from "@angular/router";
import { ModalComponent } from "components/modal/modal.component";
import { DeviceDetectorService } from "ngx-device-detector";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { lastValueFrom } from "rxjs";
import { AuthService } from "src/app/shared/auth/services/auth.service";
import { StatusJornada } from "src/app/shared/enums/Jornada/StatusJornada";
import { Perfil } from "src/app/shared/enums/Perfis/Perfis";
import { Escola } from "src/app/shared/models/escola/Escola";
import { RotaMaps } from "src/app/shared/models/maps/rota.model";
import { FimJornada, InicioJornada, JornadaPsicologo } from "src/app/shared/models/psicologo/JornadaPsicologo";
import {
  getDataCheckInModal,
  getDataHoraCheckInEfetiva,
  getHoraCheckInModal,
  getTextoEscolaParaModal,
  getUreModal,
} from "src/app/shared/utils/jornada-em-aberto-modal";
import { UserLoginSed } from "src/app/shared/models/sed/UserLogin";
import { EscolaService } from "src/app/shared/services/escola.service";
import { MapsService } from "src/app/shared/services/maps.service";
import { RelogioPontoService } from "src/app/shared/services/modal-relogioPonto.service";
import { PsicologoService } from "src/app/shared/services/psicologo.service";
@Component({
    selector: 'modal-registro-inicio-jornada',
    templateUrl: './modal-registro-inicio.component.html',
    styleUrls: ['./modal-registro-inicio.component.scss'],
    standalone: true,
    imports:[CommonModule,ModalComponent,FormsModule,]
})
export class ModalRegistroInicioComponent {

  showModal = false;
  userLogado: UserLoginSed | null;

  escolaService = inject(EscolaService);
  psicologoService = inject(PsicologoService);
  toastr = inject(ToastrService);
  deviceService = inject(DeviceDetectorService);
  spinner = inject(NgxSpinnerService);
  relogioPontoService = inject(RelogioPontoService);
  authService = inject(AuthService);
  router = inject(Router);
  mapsService = inject(MapsService);

  escola: Escola | null;
  longitude: string | undefined;
  latitude: string | undefined;
  device: string;
  infoRegistroPontoSucesso: boolean;
  acaoBtnRegistrarPonto: boolean;
  classePontoSuccess: boolean;
  motivoSelecionado: string = '';
  motivoOutro: string = '';
  mensagemRetornoSucesso: string = '';
  JornadaAtiva: JornadaPsicologo | null;
  ultimaJornadaRegistrada: JornadaPsicologo | null;
  submmited: boolean = false;
  showModalDeslocamento:boolean = false;
  deslocamento:RotaMaps | undefined;
  justificativaDistancia:string ="";
  qtdeCaracteresJustificativaDistancia:number= 0;
  disabledJustificativaDistancia:boolean  = false;
  otroDia: boolean = false;
  deveSuprimirPromptDeslocamento = false;

  // Modal "Jornada em aberto" (CA01-CA10) para bloquear novo início quando existe checkout pendente
  public showModalJornadaEmAberto: boolean = false;
  public jornadaEmAbertoParaFechar?: JornadaPsicologo | null;

  readonly jornadaAbertoResumo = {
    dataCheckIn: getDataCheckInModal,
    horaCheckIn: getHoraCheckInModal,
    ure: getUreModal,
    escola: getTextoEscolaParaModal,
  };
  public horaEncerramentoJornadaEmAberto: string = '';
  public submittedHoraEncerramentoJornadaEmAberto: boolean = false;
  public erroHoraEncerramentoJornadaEmAberto: string = '';

  private suprimirAvisosJornadaEmAberto: boolean = false;

  async ngOnInit() {
    this.relogioPontoService.modalIniciarJornada$.subscribe(async (value) => {

      if (value) {
        this.showModalJornadaEmAberto = false;
        this.jornadaEmAbertoParaFechar = null;
        this.horaEncerramentoJornadaEmAberto = '';
        this.submittedHoraEncerramentoJornadaEmAberto = false;
        this.erroHoraEncerramentoJornadaEmAberto = '';
        this.suprimirAvisosJornadaEmAberto = true;
        this.deveSuprimirPromptDeslocamento =
          this.relogioPontoService.consumirSupressaoPromptDeslocamentoNoInicioJornada();
        this.getUserLogado();
        await this.getEscolaAtual();
        await this.getJornadaEmAberto();
        this.suprimirAvisosJornadaEmAberto = false;
        if (this.JornadaAtiva) {
          // CA01-CA03: bloqueia início e solicita encerramento pendente
          this.jornadaEmAbertoParaFechar = this.JornadaAtiva;
          this.showModalJornadaEmAberto = true;
          this.showModalDeslocamento = false;
        }
        await this.getUltimaJornadaFinalizada();
        await this.getLocation();
        this.resetFields();
      }

      if(!this.showModalDeslocamento){
        this.showModal = value;
      }

    });
  }

  closeModal() {
    this.latitude = '';
    this.longitude = '';
    this.device = '';
    this.mensagemRetornoSucesso = '';
    this.motivoOutro = '';
    this.motivoSelecionado = '';
    this.relogioPontoService.fecharModalIniciarJornada();
  }

  async getEscolaAtual() {
    this.spinner.show();
    if(this.userLogado?.codigoEscola == 0)
    {
      this.tirarEscola();
    }else{
      var response = await lastValueFrom(this.escolaService.getEscolaDetalhes(this.userLogado?.codigoEscola!));
      if (!response.isSucess) {
        this.toastr.error(response.message);
        this.spinner.hide();
        return;
      }
      this.escola = response.data;
      this.spinner.hide();
    }
  }

  async RegistrarInicioJornada() {

    this.spinner.show();
    this.submmited = true;

    const limiteDistanciaKm = 1;
    const limiteDistanciaMetros = limiteDistanciaKm * 1000;

    if (this.userLogado?.autorizacaoUsoDados == 1 && await this.validarLatLong() ) {
      this.deslocamento = await this.mapsService.calculateDistance(
        +this.latitude!, +this.longitude!,
        +this.escola!.latitude, +this.escola!.longitude,
        false);
    }

    if(this.userLogado?.codigoPerfil != Perfil.Psicólogo && this.userLogado?.codigoPerfil != Perfil.CoordenadorPsicologo){
      this.toastr.error('Apenas psicólogos e Coordenador Psicólogos podem registrar jornada de trabalho!');
      return;
    }


    if (this.validaConexaoUsuario && this.motivoSelecionado === "") {
      this.toastr.error("Selecione um motivo");
      this.spinner.hide();
      this.submmited = false;
      return;
    }




    if (this.motivoSelecionado == "Outros" && (this.motivoOutro === "" || this.motivoOutro.length <= 150)) {
      this.toastr.error("Descrição vazia ou menor que 150 caracteres");
      this.spinner.hide();
      this.submmited = false;
      return;

    }
    if(this.deslocamento &&
      this.deslocamento?.totalKm! > limiteDistanciaMetros &&
      !this.justificativaDistancia &&
      this.userLogado.autorizacaoUsoDados == 1){

      this.toastr.warning(`Distância maior que ${limiteDistanciaKm}km justifique o motivo.`);
      this.spinner.hide();
      this.submmited = false;
      return;
    }

    if(this.deslocamento &&
      this.deslocamento?.totalKm! > limiteDistanciaMetros &&
      this.justificativaDistancia?.length < 10 ||
      this.justificativaDistancia.length > 500){
      this.disabledJustificativaDistancia = false;
      this.toastr.warning("A justificativa deve ser no mínimo 10 caracteres e no maximo 500.");
      this.spinner.hide();
      this.submmited = false;
      return;

    }

    var body = await this.setBodyRegistroPonto();
    try {
      var response = await lastValueFrom(this.psicologoService.registraInicioJornada(body!));
      if (!response.isSucess) {
        // Se o backend bloqueou por jornada em aberto, força o mesmo fluxo do CA01-CA07 (modal + horário).
        if ((response.message ?? '').includes('[JORNADA_EM_ABERTO]')) {
          await this.getJornadaEmAberto();
          if (this.JornadaAtiva) {
            this.jornadaEmAbertoParaFechar = this.JornadaAtiva;
            this.horaEncerramentoJornadaEmAberto = '';
            this.submittedHoraEncerramentoJornadaEmAberto = false;
            this.erroHoraEncerramentoJornadaEmAberto = '';
            this.showModalJornadaEmAberto = true;
            this.infoRegistroPontoSucesso = false;
            this.acaoBtnRegistrarPonto = true;
            this.submmited = false;
            this.relogioPontoService.updateStatusJornada(StatusJornada.EmAndamento);
            this.spinner.hide();
            return;
          }
        }

        this.toastr.error(response.message, response.title);
        this.infoRegistroPontoSucesso = false;
        this.acaoBtnRegistrarPonto = true;
        this.submmited = false;
        this.relogioPontoService.updateStatusJornada(StatusJornada.ComErro);
        this.spinner.hide();
        return;
      }

      this.mensagemRetornoSucesso = response.data.mensagem;

      // #162971 — status verde imediato; não depende do GET seguinte.
      this.relogioPontoService.updateStatusJornada(StatusJornada.Iniciada);
      this.toastr.success(`Registro de Entrada na Escola com sucesso!`);
      this.classePontoSuccess = true;
      this.infoRegistroPontoSucesso = true;
      this.acaoBtnRegistrarPonto = false;
      this.submmited = false;
      this.disabledJustificativaDistancia = true;

      this.otroDia = false;
      this.spinner.hide();
      await this.sincronizarJornadaAposCheckin(response.data?.codigoGrande);
    } catch (error: any) {
      const mensagem =
        error?.error?.message
        || error?.message
        || 'Não foi possível registrar o check-in. Verifique a conexão e tente novamente.';
      this.toastr.error(mensagem, 'Erro no check-in');
      this.infoRegistroPontoSucesso = false;
      this.acaoBtnRegistrarPonto = true;
      this.submmited = false;
      this.relogioPontoService.updateStatusJornada(StatusJornada.ComErro);
      this.spinner.hide();
    }

  }

  async onClickRegistrarEntrada() {
    // CA01-CA03: se existe jornada em aberto, bloquear novo início e solicitar checkout pendente.
    if (this.JornadaAtiva) {
      this.jornadaEmAbertoParaFechar = this.JornadaAtiva;
      this.horaEncerramentoJornadaEmAberto = '';
      this.submittedHoraEncerramentoJornadaEmAberto = false;
      this.erroHoraEncerramentoJornadaEmAberto = '';
      this.showModalJornadaEmAberto = true;
      return;
    }

    await this.RegistrarInicioJornada();
  }

  fecharModalJornadaEmAberto() {
    this.showModalJornadaEmAberto = false;
    this.jornadaEmAbertoParaFechar = null;
    this.horaEncerramentoJornadaEmAberto = '';
    this.submittedHoraEncerramentoJornadaEmAberto = false;
    this.erroHoraEncerramentoJornadaEmAberto = '';
  }

  async confirmarEncerramentoJornadaEmAberto() {
    this.submittedHoraEncerramentoJornadaEmAberto = true;
    this.erroHoraEncerramentoJornadaEmAberto = '';

    if (!this.jornadaEmAbertoParaFechar) return;
    if (!this.horaEncerramentoJornadaEmAberto) return;

    if (!/^\d{2}:\d{2}$/.test(this.horaEncerramentoJornadaEmAberto)) {
      this.erroHoraEncerramentoJornadaEmAberto = 'Horário de encerramento inválido. Use o formato HH:mm.';
      return;
    }

    const abertura = getDataHoraCheckInEfetiva(this.jornadaEmAbertoParaFechar);
    const [hhStr, mmStr] = this.horaEncerramentoJornadaEmAberto.split(':');
    const hh = Number(hhStr);
    const mm = Number(mmStr);

    if (Number.isNaN(hh) || Number.isNaN(mm)) {
      this.erroHoraEncerramentoJornadaEmAberto = 'Horário de encerramento inválido. Use o formato HH:mm.';
      return;
    }

    // CA06: mesmo dia da abertura (comparação em horário local)
    const dataFim = new Date(abertura.getFullYear(), abertura.getMonth(), abertura.getDate(), hh, mm);

    // CA09: não pode ser anterior ao início
    if (dataFim.getTime() < abertura.getTime()) {
      this.erroHoraEncerramentoJornadaEmAberto = 'O horário de encerramento não pode ser anterior ao horário de início da jornada.';
      return;
    }

    // Envia data/hora como string local (sem Z). Se mandar `Date`, o JSON vira UTC (ex.: 15:00 vira 18:00Z)
    // e o backend pode gravar a hora errada ao usar .Hour do DateTime UTC.
    const pad2 = (n: number) => String(n).padStart(2, '0');
    const y = abertura.getFullYear();
    const mo = pad2(abertura.getMonth() + 1);
    const da = pad2(abertura.getDate());
    const dataFimParaApi = `${y}-${mo}-${da}T${pad2(hh)}:${pad2(mm)}:00`;

    this.spinner.show();
    try {
      let codigoPolo = this.userLogado?.codigoPolo;
      if (!codigoPolo || codigoPolo === 0) {
        const polo = await lastValueFrom(this.psicologoService.getPoloPsicologo(this.userLogado?.cpf!));
        if (!polo.isSucess) {
          this.toastr.error(polo.message, polo.title);
          return;
        }
        codigoPolo = polo.data.codigoPolo;
      }

      // OBS: enviamos também em PascalCase para garantir o bind do ASP.NET em `FinalizaJornadaCommand`
      // (já tivemos caso de `dataFim` não bindar e o backend cair no NTP/hora atual).
      const bodyFim: FimJornada & Record<string, unknown> = {
        codigoJornada: this.jornadaEmAbertoParaFechar.codigoJornada,
        dataFim: dataFimParaApi,
        tipoRegistro: 1,
        codigoUsuario: this.userLogado?.codigoUsuario ?? Number(this.userLogado?.cpf ?? 0),
        nomeUsuario: this.userLogado?.nome ?? '',
        latitude: this.latitude,
        longitude: this.longitude,
        cpfPsicologo: this.userLogado?.cpf,
        codigoPolo,
        NrCpfCoordenador: this.userLogado?.codigoPerfil == Perfil.CoordenadorPsicologo ? this.userLogado?.cpf : undefined,
        FlCoordenador: this.userLogado?.codigoPerfil == Perfil.CoordenadorPsicologo ? true : undefined,

        // Aliases PascalCase
        CodigoJornada: this.jornadaEmAbertoParaFechar.codigoJornada,
        DataFim: dataFimParaApi,
        TipoRegistro: 1,
        CodigoUsuario: this.userLogado?.codigoUsuario ?? Number(this.userLogado?.cpf ?? 0),
        NomeUsuario: this.userLogado?.nome ?? '',
        Latitude: this.latitude,
        Longitude: this.longitude,
        CPFPsicologo: this.userLogado?.cpf,
      };

      const responseFim = await lastValueFrom(this.psicologoService.registraFimJornada(bodyFim));
      if (!responseFim.isSucess) {
        this.toastr.error(responseFim.message, responseFim.title);
        return;
      }

      // CA07: libera novo início
      this.fecharModalJornadaEmAberto();
      await this.getJornadaEmAberto();
      await this.RegistrarInicioJornada();
    } finally {
      this.spinner.hide();
    }
  }


  async setBodyRegistroPonto(): Promise<InicioJornada | void> {
    if((this.userLogado?.codigoPolo ?? 0) === 0){
      const polo = await lastValueFrom(this.psicologoService.getPoloPsicologo(this.userLogado?.cpf!));
      if (!polo.isSucess) {
        this.toastr.error(polo.message, polo.title);
        return;
      }
      this.userLogado!.codigoPolo = polo.data.codigoPolo;
    }

    var body: InicioJornada = {
      CpfPsicologo: this.userLogado?.cpf!,
      CodigoPolo: this.userLogado?.codigoPolo!,
      CodigoDiretoria: this.userLogado?.codigoDiretoria!,
      CodigoEscola: this.escola == null ? 0 : this.escola!.codigoEscola,
      TipoRegistroInicio: 1,
      NomeUsuario: this.userLogado?.nome!,
      CodigoUsuario: Number(this.userLogado?.cpf!),
      LatitudeInicio: this.userLogado?.autorizacaoUsoDados == 1 ? this.latitude : undefined,
      LongitudeInicio: this.userLogado?.autorizacaoUsoDados == 1 ? this.longitude : undefined,
      Observacao: this.tratarObservacao(),
      DistanciaEscola: this.deslocamento?.totalKmFormatado,
      TempoDeslocamento: this.deslocamento?.totalDuration,
      JustificativaDistancia:this.justificativaDistancia,
      NrCpfCoordenador: this.userLogado?.codigoPerfil == Perfil.CoordenadorPsicologo ? this.userLogado?.cpf : undefined,
      FlCoordenador: this.userLogado?.codigoPerfil == Perfil.CoordenadorPsicologo ? true : undefined,
    };

    return body;

  }
  private tratarObservacao() {
    let observacao = this.motivoSelecionado;

    if (this.motivoSelecionado == "Outros") {
      observacao = this.motivoOutro;
    }
    
    if (this.userLogado?.autorizacaoUsoDados != 1) {
      observacao = "Sem autorização do uso de dados";
    }

    return observacao;
  }

  async getLocation(): Promise<void> {

    const deviceInfo = this.deviceService.getDeviceInfo();

    // if(deviceInfo.deviceType === 'desktop'){
    //   this.toastr.error(`Geolocalização não suportada em dispositivos Desktop.`);
    //   console.error('Geolocalização não suportada em dispositivos Desktop.');
    //   return;
    // }
    // Tablet - Desktop - Mobile

    if ('connection' in navigator) {
      const connection = (navigator as any).connection;

    }

    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream;

    // Configuración específica para iOS
    const options: PositionOptions = {
      enableHighAccuracy: true,
      timeout: isIOS ? 10000 : 5000, // Aumentamos el timeout para iOS
      maximumAge: 0
    };

    try {
      // Primero verificamos si la geolocalización está disponible
      if (!('geolocation' in navigator)) {
        throw new Error('Geolocalização não suportada neste navegador.');
      }

      // Verificamos el estado del permiso
      const permissionStatus = await this.checkLocationPermission();
      if (permissionStatus === 'denied') {
        throw new Error('Permissão de localização negada pelo usuário.');
      }

      // Intentamos obtener la ubicación con un timeout
      const position = await this.getPositionWithTimeout(options);

      this.latitude = position.coords.latitude.toString();
      this.longitude = position.coords.longitude.toString();
      this.device = deviceInfo.deviceType;

      // Verificación adicional de coordenadas válidas
      if (!this.isValidCoordinates(+this.latitude, +this.longitude)) {
        throw new Error('Coordenadas inválidas obtidas.');
      }

    } catch (error: any) {
      console.error('Erro na geolocalização:', error);

      // Mensajes de error más específicos
      let errorMessage = 'Erro ao obter a localização.';

      if (error.code === 1) {
        errorMessage = 'Permissão de localização negada. Por favor, verifique as configurações do seu dispositivo.';
      } else if (error.code === 2) {
        errorMessage = 'Localização indisponível. Verifique se o GPS está ativado.';
      } else if (error.code === 3) {
        errorMessage = 'Tempo esgotado ao obter localização. Tente novamente.';
      } else if (error.message) {
        errorMessage = error.message;
      }

      this.toastr.error(errorMessage);

      // Para iOS, podemos sugerir verificar la configuración
      if (isIOS) {
        this.toastr.info('Em dispositivos iOS, verifique se a localização está ativada em: Configurações > Privacidade > Serviços de Localização > Safari');
      }
    }
  }

  // Función auxiliar para verificar el permiso de ubicación
  private async checkLocationPermission(): Promise<PermissionState> {
    if (!navigator.permissions || !navigator.permissions.query) {
      return 'prompt';
    }

    try {
      const result = await navigator.permissions.query({ name: 'geolocation' });
      return result.state;
    } catch {
      return 'prompt';
    }
  }

  // Función auxiliar para obtener la posición con timeout
  private getPositionWithTimeout(options: PositionOptions): Promise<GeolocationPosition> {
    return new Promise((resolve, reject) => {
      const timeoutId = setTimeout(() => {
        reject(new Error('Tempo esgotado ao obter localização'));
      }, options.timeout);

      navigator.geolocation.getCurrentPosition(
        (position) => {
          clearTimeout(timeoutId);
          resolve(position);
        },
        (error) => {
          clearTimeout(timeoutId);
          reject(error);
        },
        options
      );
    });
  }

  // Función auxiliar para validar coordenadas
  private isValidCoordinates(lat: number, lng: number): boolean {
    return !isNaN(lat) &&
          !isNaN(lng) &&
          lat !== 0 &&
          lng !== 0 &&
          lat >= -90 &&
          lat <= 90 &&
          lng >= -180 &&
          lng <= 180;
  }

  /**
   * #162971 — Após check-in bem-sucedido, sincroniza jornada sem rebaixar o status visual se o GET vier null.
   */
  private async sincronizarJornadaAposCheckin(codigoJornadaCriada?: number | null): Promise<void> {
    const maxTentativas = 3;
    this.suprimirAvisosJornadaEmAberto = true;
    try {
      for (let tentativa = 1; tentativa <= maxTentativas; tentativa++) {
        const sincronizou = await this.getJornadaEmAberto({ preservarStatusSeNulo: true });
        if (sincronizou) {
          return;
        }
        if (tentativa < maxTentativas) {
          await new Promise(resolve => setTimeout(resolve, 300 * tentativa));
        }
      }

      // Mantém verde (Iniciada → EmAndamento) mesmo sem payload completo do GET.
      this.relogioPontoService.updateStatusJornada(StatusJornada.EmAndamento);
      if (codigoJornadaCriada && codigoJornadaCriada > 0 && !this.JornadaAtiva) {
        this.JornadaAtiva = {
          codigoJornada: codigoJornadaCriada,
        } as JornadaPsicologo;
      }
      this.toastr.warning(
        'Check-in registrado, mas o status da jornada ainda não foi confirmado pelo servidor. Atualize a página se as atividades permanecerem bloqueadas.',
        'Atenção'
      );
    } finally {
      this.suprimirAvisosJornadaEmAberto = false;
    }
  }

  async getJornadaEmAberto(opcoes?: { preservarStatusSeNulo?: boolean }): Promise<boolean> {
    this.spinner.show();
    this.otroDia = false;
    try {
      const response = await lastValueFrom(this.psicologoService.getJornadaEmAberto(this.userLogado?.cpf!));
      if (!response.isSucess) {
        this.toastr.error(response.message, response.title);
        this.spinner.hide();
        return false;
      }

      if (response.data !== null) {

        this.JornadaAtiva = response.data;

        const dataInicioJornada = new Date(response.data.dataInicio);
        const hoje = new Date();
        const inicioDiaHoje = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate());
        const inicioDiaJornada = new Date(dataInicioJornada.getFullYear(), dataInicioJornada.getMonth(), dataInicioJornada.getDate());
        const diffDias = Math.floor((inicioDiaHoje.getTime() - inicioDiaJornada.getTime()) / (24 * 60 * 60 * 1000));

        // Se existe jornada em aberto (DT_FIM null), o topo deve ficar verde (em andamento),
        // mesmo que o início tenha sido em dia anterior.
        this.relogioPontoService.updateStatusJornada(StatusJornada.EmAndamento);

        // Revisa se existe diferença de dias (para exibir mensagem/fluxo de acerto)
        if(diffDias > 0){
          this.mensagemRetornoSucesso = `Jornada maior que 1 dia, iniciada as ${this.JornadaAtiva!.horaInicio}`;
          if (!this.suprimirAvisosJornadaEmAberto) {
            this.toastr.warning('Check-out do último dia trabalhado ainda não realizado. Favor efetuar o acerto na tela de Painel de Atividade do Psicólogo');
          }
          this.otroDia = true;
        } else {
          this.mensagemRetornoSucesso = `Jornada iniciada as ${this.JornadaAtiva!.horaInicio}`;
          if (!this.suprimirAvisosJornadaEmAberto) {
            this.toastr.warning(`Jornada em andamento, iniciada as ${this.JornadaAtiva!.horaInicio}`, 'Atenção!');
          }
        }
        this.spinner.hide();
        return true;
      }

      // #162971 — após check-in bem-sucedido, não rebaixar para NaoIniciada se o GET vier null.
      if (!opcoes?.preservarStatusSeNulo) {
        this.JornadaAtiva = null;
        this.mensagemRetornoSucesso = '';
        this.relogioPontoService.updateStatusJornada(StatusJornada.NaoIniciada);
        this.infoRegistroPontoSucesso = false;
      }
      this.spinner.hide();
      return false;
    } catch (error: any) {
      const mensagem =
        error?.error?.message
        || error?.message
        || 'Não foi possível consultar o status da jornada. Tente novamente.';
      this.toastr.error(mensagem, 'Erro');
      this.spinner.hide();
      return false;
    }
  }

  public async tirarEscola() {
    this.escola = new Escola();
    this.escola!.codigoEscola = 0;
    this.escola!.nomeEscola = '';
    const response = await lastValueFrom(this.escolaService.getDiretoriaPorCodigo(this.userLogado?.codigoDiretoria!));
    if (!response.isSucess) {
      this.toastr.error(response.message, response.title);
      this.spinner.hide();
      return;
    }
    var diretoria = response.data[0];
    if(response.data) {
      if (diretoria.latitude && diretoria.longitude) {
        this.escola!.latitude = diretoria.latitude;
        this.escola!.longitude = diretoria.longitude;
        this.escola!.codigoEscola = 0;
        this.escola!.nomeEscola = '';
        this.escola!.nomeDiretoria = diretoria.nomeDiretoria;
      } else {
        console.warn('Diretoria não possui latitude/longitude definidos');
      }
    }
  }

  async getUltimaJornadaFinalizada() {
    this.spinner.show();

    const response = await lastValueFrom(this.psicologoService.getUltimaJornadaFinalizada(this.userLogado?.cpf!));
    if (!response.isSucess) {
      this.toastr.error(response.message, response.title);
      this.spinner.hide();
      return;
    }

    this.ultimaJornadaRegistrada = response.data;

    // Se já existe jornada em aberto, não faz sentido abrir modal de deslocamento.
    // O fluxo correto é bloquear o novo início e pedir o checkout pendente (Jornada em aberto).
    if (
      !this.JornadaAtiva &&
      this.ultimaJornadaRegistrada != null &&
      !this.deveSuprimirPromptDeslocamento
    ) {
      this.showModalDeslocamento = true;
    } else {
      this.showModalDeslocamento = false;
    }

    this.spinner.hide();
  }

  get validaConexaoUsuario(): boolean {
    return !this.latitude
      && !this.longitude
      && !this.mensagemRetornoSucesso
      && !this.JornadaAtiva;
  }

  getUserLogado() {
    this.userLogado = this.authService.getUser();
    if (!this.userLogado)
      this.router.navigate(['/logout']);

  }

  public async validarLatLong(): Promise<boolean> {

    if(!this.longitude || !this.latitude)
      return false;

    if (this.escola &&
      +this.escola.latitude! != 0 &&
      +this.escola.longitude! != 0 &&
      +this.latitude! != 0 &&
      +this.longitude! != 0) {
      return true;
    }    

    if(this.userLogado?.apenasDiretoria) {
      return true;      
    }

    if (this.escola?.latitude && +this.escola.latitude == 0
      && this.escola?.longitude && +this.escola.longitude == 0) {
      this.toastr.error(`A Escola ${this.escola.nomeEscola} está com problema na Lat/Long ... `, 'Atenção!');
    }

    if (this.latitude && +this.latitude == 0
      && this.longitude && +this.longitude == 0) {
      this.toastr.error(`Há um problema na sua Lat/Long ... `, 'Atenção!');
    }

    return false;
  }



  FecharModal(){
    this.showModalDeslocamento = false;
  }

  AbrirModalJornada(){
    this.FecharModal();
    this.showModal = true;
  }

  redirectToDeslocamento(){
    this.showModalDeslocamento = false;
    this.router.navigate(['/deslocamento-jornada'])
  }

  OnChangeCountLetters(){
    if (this.justificativaDistancia != null)
      this.qtdeCaracteresJustificativaDistancia = this.justificativaDistancia.length;
  }

  resetFields(){
    this.disabledJustificativaDistancia = false;
    this.justificativaDistancia = "";
    this.motivoOutro = "";
    this.motivoSelecionado = "";
  }
}

